import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46ac4068"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "target-accomplished" }
const _hoisted_2 = { class: "target-accomplished-container" }
const _hoisted_3 = { class: "titles d-flex justify-content-between" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "Meta x Realizado Por Canal", -1))
const _hoisted_5 = { class: "card-title" }
const _hoisted_6 = {
  key: 1,
  class: "flex-legend"
}
const _hoisted_7 = { class: "legend" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "box-legend billed" }),
  /*#__PURE__*/_createElementVNode("div", { class: "textLegend" }, "Faturado")
], -1))
const _hoisted_9 = { class: "legend" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "box-legend inbilling" }),
  /*#__PURE__*/_createElementVNode("div", { class: "textLegend" }, "Em Faturamento")
], -1))
const _hoisted_11 = { class: "legend" }
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "textLegend" }, "Saldo", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Overlay = _resolveComponent("Overlay")!
  const _component_NoAccess = _resolveComponent("NoAccess")!
  const _component_VChart = _resolveComponent("VChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Overlay, { key: 0 }))
      : _createCommentVNode("", true),
    (!_ctx.access && !_ctx.loading)
      ? (_openBlock(), _createBlock(_component_NoAccess, { key: 1 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.salesChannelName), 1)
      ]),
      (_ctx.access)
        ? (_openBlock(), _createBlock(_component_VChart, {
            key: 0,
            ref: "chart",
            class: _normalizeClass(["chart", {
          loadingClass: _ctx.loading,
        }]),
            option: _ctx.options,
            autoresize: ""
          }, null, 8, ["option", "class"]))
        : _createCommentVNode("", true),
      (!_ctx.loading && _ctx.access)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", null, [
                _createElementVNode("h5", null, _toDisplayString(_ctx.targetAccomplished?.channelRevenueValue
                  ?.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    style: 'currency',
                    currency: 'BRL',
                  })
                  .split(',')[0]), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", null, [
                _createElementVNode("h5", null, _toDisplayString(_ctx.targetAccomplished?.channelInvoiceValue
                  ?.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    style: 'currency',
                    currency: 'BRL',
                  })
                  .split(',')[0]), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", {
                  class: _normalizeClass(["box-legend balance", {
                'positive-value': _ctx.targetAccomplished.channelBalanceValue > 0,
              }])
                }, null, 2),
                _hoisted_13
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("h5", null, _toDisplayString(_ctx.targetAccomplished?.channelBalanceValue
                  ?.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    style: 'currency',
                    currency: 'BRL',
                  })
                  .split(',')[0]), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}